import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 142px)'
  },
  stepperContainer: {
    padding: theme.spacing(3),
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  customStepper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    width: '100%',
    paddingLeft: '8%',
    paddingRight: '8%'
  },
  stepIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: 100
  },
  stepCircle: {
    borderRadius: '50%',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 80
  },
  pastStepCircle: {
    border: `2px solid ${theme.palette.primary.main}`, // Red border for past steps
    color: theme.palette.primary.main // Red color for past step icon
  },
  activeStepCircle: {
    border: `2px solid ${theme.palette.primary.main}`, // Red border for active step
    boxShadow: '0 0 8px rgba(211, 47, 47, 0.5)', // Red shadow for active step
    color: theme.palette.primary.main // Red color for active step icon
  },
  inactiveStepCircle: {
    border: `2px dashed ${theme.palette.grey[500]}`, // Dashed gray border for inactive steps
    color: theme.palette.grey[500] // Gray color for inactive step icon
  },
  stepLabel: {
    fontWeight: 500,
    marginTop: theme.spacing(1)
  },
  pastStepLabel: {
    color: theme.palette.primary.main // Red color for past step label
  },
  activeStepLabel: {
    color: theme.palette.primary.main // Red color for active step label
  },
  inactiveStepLabel: {
    color: theme.palette.grey[500] // Gray color for inactive step label
  },
  activeConnectorLine: {
    height: 2,
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    margin: '0 12px',
    marginTop: 39
  },
  inactiveConnectorLine: {
    height: 2,
    width: '100%',
    borderBottom: `2px dashed ${theme.palette.grey[500]}`, // Dashed gray line for inactive connectors
    margin: '0 12px',
    marginTop: 39
  },
  singleConnectorLine: {
    height: 2,
    width: '100%',
    borderBottom: `2px dashed ${theme.palette.grey[500]}`, // Dashed gray line for inactive connectors
    margin: '0 12px',
    paddingTop: 40,
    marginRight: '60%'
  },

  stepContent: {
    padding: theme.spacing(2),
    // minHeight: '200px',
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // backgroundColor: theme.palette.primary.contrastText,
    // borderRadius: 8,
    // width: '100%',
    // marginTop: theme.spacing(3),
    overflowY: 'auto',
    height: '60%'
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    width: '98%',
    position: 'absolute',
    paddingBottom: 40,
    bottom: 0,
    left: '1%',
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.grey[500]}`,
    paddingTop: 20
  },
  button: {
    minWidth: 100,
    fontWeight: 600
  }
}))

export default useStyles
